import React from "react";

const Bell = () => {
    return (
        <div className="ftm-request-notification-body">
            <h3>RE-CALL VISIT</h3>
            <img src="/assets/gif/bell.gif" className="ftm-request-notification-body-icon" alt="bellIcon"/>
            <p className="r3 px-md-5 px-sm-1">A new re-call job requires your attention</p>
        </div>
    );
};

export default Bell;